export const CARD_ISSUES_WITH_CLAIM = [
  { id: 0, key: 0, display: 'Did not receive my card' },
  { id: 0, key: 1, display: 'Other'  },
  { id: 1, key: 2, display: 'Balance discrepancy' },
  { id: 2, key: 3, display: 'Card missing information' },
  { id: 3, key: 4, display: 'Card number invalid' },
  { id: 4, key: 5, display: 'Not accepted by merchant' }
];

export const CARD_ISSUES_WITHOUT_CLAIM = [
  { id: 0, key: 0, display: 'Did not receive my card' },
  { id: 0, key: 1, display: 'Other'  }
];

export const MISSING_INFO_OPTIONS = [
  { key: 6, display: 'Card number' },
  { key: 7, display: 'Pin number' },
  { key: 8, display: 'Merchant\'s name' },
  { key: 9, display: 'Barcode' },
  { key: 10, display: 'Other' }
];

export const CARD_NUMBER_INVALID_OPTIONS = [
  { key: 11, display: 'Instore' },
  { key: 12, display: 'Online' },
  { key: 13, display: 'Both' }
];

export const BALANCE_DISCREPANCY_OPTIONS = [
  { key: 14, display: 'Instore' },
  { key: 15, display: 'Online' },
  { key: 16, display: 'Both' },
  { key: 17, display: 'Did a balance check' }
];

export const NOT_ACCEPTED_BY_MERCHANT_OPTIONS = [
  { key: 18, display: 'Instore' },
  { key: 19, display: 'Online' },
  { key: 20, display: 'Both' },
  { key: 21, display: 'Did a balance check' }
];
